




























import { Component, Vue, Prop } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";

@Component
export default class ActorCard extends Vue {
  @Prop(Object) studio!: any;
  @Prop({ default: true }) showLabels!: boolean;

  get labelNames() {
    return this.studio.labels.map((l) => l.name).sort();
  }

  get thumbnail() {
    if (this.studio.thumbnail)
      return `${serverBase}/media/image/${
        this.studio.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }
}
